import * as React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import CONSTANT from "./constant";
import { getAuthToken, getCookie, getStorage, getUserDetail } from "./utils";

// import Home from './container/Home';
import ForgotPassword from "./container/auth/ForgotPassword";
import Login from "./container/auth/Login";
import Logout from "./container/auth/Logout";
import ResetPassword from "./container/auth/ResetPassword";
import FourZeroFour from "./container/error/FourZeroFour";

import AdminAddUser from "./container/admin/user/Add";
import AdminEditUser from "./container/admin/user/Edit";
import AdminUserExcel from "./container/admin/user/Excel";
import AdminUserList from "./container/admin/user/List";
import AdminLoginAs from "./container/admin/user/LoginAs";
import AdminUserSearch from "./container/admin/user/Search";

import AdminAddLeave from "./container/admin/leave/Add";
import AdminLeaveBulkUpdate from "./container/admin/leave/BulkUpdateBalance";
import AdminExcelBulkBalance from "./container/admin/leave/ExcelBulkBalance";
import AdminLeaveBalanceUpdateLog from "./container/admin/leave/LeaveBalanceUpdateLog";
import AdminOrganisationLeaveRequestDetail from "./container/admin/leave/LeaveRequestDetail";
import AdminOrganisationLeaveRequestList from "./container/admin/leave/LeaveRequestList";
import AdminLeaveList from "./container/admin/leave/List";
import AdminMonthlyLeaveReport from "./container/admin/leave/MonthlyReport";
import AdminLeaveSearch from "./container/admin/leave/Search";

import AdminAddDepartment from "./container/admin/department/Add";
import AdminDepartmentList from "./container/admin/department/List";
import AdminOrganisationEncashmentRequestDetail from "./container/admin/leave/EncashmentRequestDetail";
import AdminOrganisationEncashmentRequestList from "./container/admin/leave/EncashmentRequestList";

import AdminAddDesignation from "./container/admin/designation/Add";
import AdminEditDesignation from "./container/admin/designation/Edit";
import AdminDesignationList from "./container/admin/designation/List";

import AdminAddGradeList from "./container/admin/grade/Add";
import AdminGradeList from "./container/admin/grade/List";

import AdminAddGroupList from "./container/admin/group/Add";
import AdminGroupList from "./container/admin/group/List";

import AdminAddUnitList from "./container/admin/unit/Add";
import AdminUnitList from "./container/admin/unit/List";

import AdminAddHoliday from "./container/admin/holiday/Add";
import AdminEditHoliday from "./container/admin/holiday/Edit";
import AdminHolidayList from "./container/admin/holiday/List";

import AdminDak from "./container/admin/dak/list";
import AdminDashboardLinkList from "./container/admin/dashboardLink/List";
import AdminAddDashboardLink from "./container/admin/dashboardLink/Add";
import AdminAddNoting from "./container/admin/noting/Add";
import AdminEditNotingList from "./container/admin/noting/Edit";
import AdminNotingList from "./container/admin/noting/List";

import PrintLog from "./container/admin/printLog/printLog";
import FileCreationReport from "./container/admin/fileCreationReport/FileCreationReport";
import LoginLog from "./container/admin/loginLog/LoginLog";
import UnitAddLeave from "./container/admin/unit-leave/Add";
import UnitLeaveBulkUpdate from "./container/admin/unit-leave/BulkUpdateBalance";
import UnitLeaveList from "./container/admin/unit-leave/List";
import UnitProxyLeaveDetail from "./container/admin/unit-leave/ProxyLeaveDetail";
import UnitProxyLeaveList from "./container/admin/unit-leave/ProxyLeaveList";
import UnitProxyLeaveRequest from "./container/admin/unit-leave/ProxyLeaveRequest";

import UnitEncashmentList from "./container/admin/unit-leave/unitEncashmentList";

import MainFileCreate from "./container/file/Add";
import MainFileCreate2 from "./container/file/AddBak";
import ApprovedFileList from "./container/file/ApprovedFileList";
import UserClosedFileList from "./container/file/Closed";
import UserFileDetail from "./container/file/Detail";
import HODFileReport from "./container/file/HODReport";
import UserFileList from "./container/file/List";
import UserSearchFile from "./container/file/Search";

// import Logo from './../src/assets/images/logo.png';
import Logo from "./assets/images/logo.png";

import Userpic from "./assets/images/userpic.png";
// import CommiteNoteList from './container/commiteNote/List';
// import AddCommiteNote from './container/commiteNote/Add';

import UserChangePassword from "./container/profile/ChangePassword";
import UserProfile from "./container/profile/Detail";

import UserApplyLeave from "./container/leave/Apply";
import UserLeaveDetail from "./container/leave/Detail";
import UserLeaveList from "./container/leave/List";

import UserLeaveEncashmentAdd from "./container/leave-encashment/Apply";
import UserLeaveEncashmentDetail from "./container/leave-encashment/Detail";
import UserLeaveEncashmentList from "./container/leave-encashment/List";

import AddEtourRequest from "./container/etour/Add";
import UserEtourDetail from "./container/etour/Detail";
import EtourList from "./container/etour/List";
import KnowledgeManagement from "./container/knowledgeManagement";
import AddReimbursementDetail from "./container/reimbursement/Add";

import AddMedicalClaim from "./container/MedicalClaim/AddMedicalClaim";

import DakManagementCreate from "./container/dakManagement";
import DakManagementList from "./container/dakManagement/list";
import DakManagementUpdate from "./container/dakManagement/update";
import DraftList from "./container/file-draft/List";
import AddEfilling from "./container/file/AddEfilling";
import DltTempFiles from "./container/file/DltTempFiles";
import AppliedMedical from "./container/MedicalClaim/AppliedMedical";
import ListMedicals from "./container/MedicalClaim/ListMedicals";
import MedicalDesk from "./container/MedicalClaim/MedicalDesk";
import ProbationCompletionConfirmation from "./container/probationCompletionConfirmation";
import ProbationCompletionInitiation from "./container/probationCompletionInitiation";

import IntitateParkedFile from "./container/parked_file/IntitateParkedFile";
import ParkedFileComment from "./container/parked_file/ParkedFileComment";

import CircularDetail from "./component/circular_module/CircularDetail";
import CircularListFormAdd from "./component/circular_module/CircularForm";
import CircularList from "./component/circular_module/CircularList";
import Header, { SessionTimer } from "./component/common/Header";
import SessionOut from "./component/SessionOut/SessionOut";
import LoginWithOtp from "./container/auth/LogInWithOtp";
import TestLogin from "./container/auth/TestLogin";
import SuperUserDashboard from "./container/SuperUser/Dashboard";
import SuperUser from "./container/SuperUser/SuperUser";
import NavbarSidebar from "./component/common/NavbarSidebar";
import MyFiles from "./container/file/MyFiles";
import Inbox from "./container/file/Inbox";
import Outbox from "./container/file/Outbox";
import PendingHodFiles from "./container/file/PendingHodFiles";
import HodApproveFile from "./container/file/HodApproveFile";
import DraftFiles from "./container/file/DraftFiles";
import FileStatsDashboard from "./container/file/FileStatsDashboard";
import AdminHeader from "./component/common/AdminHeader";
import EmpPropertyReturn from "./container/EmpPropertyReturn/EmpPropertyReturn";
import HrPropertyReturnList from "./container/EmpPropertyReturn/HrPropertyReturnList";
import constant from "./constant";
import PartFile from "./container/file/PartFile";
// import Esign from "./component/Esign";

const AdminRoute = (props: any) => {
  const token = getCookie(CONSTANT.cookie.token);
  const permissionList = getStorage(CONSTANT.cookie.permissions);
  const path = props.path;
  const urlKeys = Object.entries(CONSTANT.component);
  const match: any = urlKeys.filter((i: any) => i[1].url === path);
  const ud = getUserDetail();

  if (token) {
    if (match.length > 0 && match[0][1].url === path) {
      const permissionId = match[0][1].permissionId;
      if (permissionList.indexOf(permissionId) > -1) {
        return (
          <>
            {/* <TopNavbar userDetails={ud}/> */}
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark topmenu">
              <div className="container-fluid">
                <img src={Logo} style={{ width: "auto", height: "70px" }} />
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarNav"
                  aria-controls="navbarNav"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon" />
                </button>
                <div className="mobpad">
                  <ul className="navbar-nav ms-md-auto gap-2 flex-row">
                    <li>{ud && <SessionTimer />}</li>
                    <li className="nav-item dropdown rounded">
                      <a
                        className="nav-link dropdown-toggle"
                        href="#"
                        id="navbarDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <img src={Userpic} style={{ maxWidth: "34px" }} />
                      </a>
                      <ul
                        className="dropdown-menu dropdown-menu-end"
                        aria-labelledby="navbarDropdown"
                      >
                        <li>
                          <a
                            className="dropdown-item"
                            href={CONSTANT.component.userProfile.url}
                          >
                            {ud?.name}
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            href={CONSTANT.component.userChangePassword.url}
                          >
                            Change Password
                          </a>
                        </li>
                        <li>
                          <hr className="dropdown-divider" />
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            href={CONSTANT.component.logout.url}
                          >
                            Logout
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
            <div className="flex bg-gray-100 h-screen">
              <AdminHeader />
              {/* <NavbarSidebar /> */}
              <div className="flex-1">
                {/* <Component {...routeProps} /> */}
                {/* <Route {...props} /> */}
                <Route
                  exact={true}
                  path={props.path}
                  component={props.component}
                />
              </div>
            </div>
          </>
        );
      } else {
        return <FourZeroFour />;
      }
    } else {
      return <FourZeroFour />;
    }
  } else {
    return <Route exact={true} path={props.path} component={Login} />;
  }
};

const PrivateRoute = (props: any) => {
  const ud = getUserDetail();
  if (
    getAuthToken() &&
    ud?.employeeNumber !==
      constant.component.EmpPropertyReturnForHr.permissionId
  ) {
    return (
      <>
        {/* <TopNavbar userDetails={ud}/> */}
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark topmenu">
          <div className="container-fluid">
            <img src={Logo} style={{ width: "auto", height: "70px" }} />
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon" />
            </button>
            <div className="mobpad">
              <ul className="navbar-nav ms-md-auto gap-2 flex-row">
                <li>{ud && <SessionTimer />}</li>
                <li className="nav-item dropdown rounded">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img src={Userpic} style={{ maxWidth: "34px" }} />
                  </a>
                  <ul
                    className="dropdown-menu dropdown-menu-end"
                    aria-labelledby="navbarDropdown"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        href={CONSTANT.component.userProfile.url}
                      >
                        {ud?.name}
                      </a>
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href={CONSTANT.component.userChangePassword.url}
                      >
                        Change Password
                      </a>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href={CONSTANT.component.logout.url}
                      >
                        Logout
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        <div className="flex bg-gray-100">
          <Header />
          {/* <NavbarSidebar /> */}
          <div className="flex-1 w-100">
            {/* <Component {...routeProps} /> */}
            <Route {...props} />
          </div>
        </div>
        {/* <NavbarSidebar /> */}
        <div className="footer_bottom bg-white p-3">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-12 col-md-12">
                <div className="copyright_area text-center">
                  <p className="p-1">
                    Site Is Designed And Updated By Engineering Projects (India)
                    Ltd.
                  </p>
                  <p>
                    © 2025{" "}
                    <span className="font-medium">
                      {" "}
                      Engineering Projects (India) Ltd.
                    </span>
                    {/* <i className="fa fa-heart text-red-500"></i>  */}
                    All Rights Reserved.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else if (
    getAuthToken() &&
    ud?.employeeNumber ===
      constant.component.EmpPropertyReturnForHr.permissionId
  ) {
    return (
      <Redirect
        exact={true}
        to={constant.component.EmpPropertyReturnForHr.url}
      />
    );
  } else {
    return (
      <Redirect
        exact={true}
        to={{ pathname: CONSTANT.component.error, state: { from: props.path } }}
      />
    );
  }
};

const EmpPropertyRoute = (props: any) => {
  const ud = getUserDetail();

  if (
    getAuthToken() &&
    ud?.employeeNumber ===
      constant.component.EmpPropertyReturnForHr.permissionId
  ) {
    return (
      <>
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark topmenu">
          <div className="container-fluid">
            <img src={Logo} style={{ width: "auto", height: "70px" }} />

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
            >
              <span className="navbar-toggler-icon" />
            </button>

            <div className="mobpad">
              <ul className="navbar-nav ms-md-auto gap-2 flex-row">
                <li>{ud && <SessionTimer />}</li>

                <li className="nav-item dropdown rounded">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                  >
                    <img src={Userpic} style={{ maxWidth: "34px" }} />
                  </a>

                  <ul className="dropdown-menu dropdown-menu-end">
                    <li>
                      <a
                        className="dropdown-item"
                        href={CONSTANT.component.userProfile.url}
                      >
                        {ud?.name}
                      </a>
                    </li>

                    <li>
                      <a
                        className="dropdown-item"
                        href={CONSTANT.component.userChangePassword.url}
                      >
                        Change Password
                      </a>
                    </li>

                    <li>
                      <hr className="dropdown-divider" />
                    </li>

                    <li>
                      <a
                        className="dropdown-item"
                        href={CONSTANT.component.logout.url}
                      >
                        Logout
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <Route {...props} />

        <div className="footer_bottom bg-white p-3">
          <div className="container text-center">
            <p className="p-1">
              Site Is Designed And Updated By Engineering Projects (India) Ltd.
            </p>
            <p>
              © 2025{" "}
              <span className="font-medium">
                Engineering Projects (India) Ltd.
              </span>
              All Rights Reserved.
            </p>
          </div>
        </div>
      </>
    );
  }

  // ❌ If token missing OR code is not 1771
  return <Redirect to={constant.component.userFileList.url} />;
};

const Router = (props: any) => {
  return (
    <Switch>
      {/* <Route
      exact={true}
      path={"/commentmodel"}
      component={CommentModel}
    /> */}
      {/* <Route
        exact={true}
        path={CONSTANT.component.home.url}
        component={LoginWithOtp}
      /> */}
      <Route
        exact={true}
        path={CONSTANT.component.home.url}
        component={Login}
      />
      {/* <Route
        exact={true}
        path={CONSTANT.component.login.url}
        component={Login}
      /> */}
      <Route
        exact={true}
        path={CONSTANT.component.loginwithotp.url}
        component={LoginWithOtp}
      />
      <Route exact={true} path={"/test-login"} component={TestLogin} />
      <Route
        exact={true}
        path={CONSTANT.component.logout.url}
        component={Logout}
      />
      <Route
        exact={true}
        path={CONSTANT.component.forgotPassword.url}
        component={ForgotPassword}
      />
      <Route
        exact={true}
        path={CONSTANT.component.superUser.url}
        component={SuperUser}
      />
      <Route
        exact={true}
        path={CONSTANT.component.superUser.url}
        component={SuperUser}
      />
      <Route
        exact={true}
        path={CONSTANT.component.superUserDashboard.url}
        component={SuperUserDashboard}
      />
      <Route exact={true} path={"/session-out"} component={SessionOut} />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.probationCompletionConfirmation.url}
        component={ProbationCompletionConfirmation}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.probationCompletionInitiation.url}
        component={ProbationCompletionInitiation}
      />
      <Route
        exact={true}
        path={CONSTANT.component.resetPassword.url}
        component={ResetPassword}
      />
      {/* Unit Leave Routes */}
      <AdminRoute
        exact={true}
        path={CONSTANT.component.unitLeaveReport.url}
        component={UnitLeaveList}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.unitBulkUpdateLeave.url}
        component={UnitLeaveBulkUpdate}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminPrintLog.url}
        component={PrintLog}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminFileCreationReport.url}
        component={FileCreationReport}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminLoginLog.url}
        component={LoginLog}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.unitProxyLeaveList.url}
        component={UnitProxyLeaveList}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.unitProxyLeaveRequest.url}
        component={UnitProxyLeaveRequest}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.unitProxyLeaveDetail.url}
        component={UnitProxyLeaveDetail}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.unitAddLeave.url}
        component={UnitAddLeave}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.unitEncashmentList.url}
        component={UnitEncashmentList}
      />
      {/* Unit Leave Routes */}
      {/* admin routes */}
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminLeaveManager.url}
        component={AdminLeaveList}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminLeaveBalanceUpdateLog.url}
        component={AdminLeaveBalanceUpdateLog}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminOrganisationLeaveRequestList.url}
        component={AdminOrganisationLeaveRequestList}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminOrganisationLeaveRequestDetail.url}
        component={AdminOrganisationLeaveRequestDetail}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminBulkUpdateLeave.url}
        component={AdminLeaveBulkUpdate}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminBulkUploadLeaveBalance.url}
        component={AdminExcelBulkBalance}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminSearchLeave.url}
        component={AdminLeaveSearch}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminMonthlyLeaveReport.url}
        component={AdminMonthlyLeaveReport}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.adminAddLeave.url}
        component={AdminAddLeave}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminOrganisationEncashmentRequestList.url}
        component={AdminOrganisationEncashmentRequestList}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminOrganisationEncashmentRequestDetail.url}
        component={AdminOrganisationEncashmentRequestDetail}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminDashboard.url}
        component={AdminUserList}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminUserList.url}
        component={AdminUserList}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminSearchUser.url}
        component={AdminUserSearch}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminLoginAs.url}
        component={AdminLoginAs}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminUploadUserExcel.url}
        component={AdminUserExcel}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminAddUser.url}
        component={AdminAddUser}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminEditUser.url}
        component={AdminEditUser}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminDepartmentList.url}
        component={AdminDepartmentList}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminAddDepartment.url}
        component={AdminAddDepartment}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminDesignationList.url}
        component={AdminDesignationList}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminAddDesignation.url}
        component={AdminAddDesignation}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminEditDesignation.url}
        component={AdminEditDesignation}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminGradeList.url}
        component={AdminGradeList}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminAddGradeList.url}
        component={AdminAddGradeList}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminGroupList.url}
        component={AdminGroupList}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminAddGroupList.url}
        component={AdminAddGroupList}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminUnitList.url}
        component={AdminUnitList}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminAddUnitList.url}
        component={AdminAddUnitList}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminHolidayList.url}
        component={AdminHolidayList}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminAddDashboardLink.url}
        component={AdminAddDashboardLink}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminDashboardLinkList.url}
        component={AdminDashboardLinkList}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminAddHoliday.url}
        component={AdminAddHoliday}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminEditHoliday.url}
        component={AdminEditHoliday}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminNoting.url}
        component={AdminNotingList}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminEditNoting.url}
        component={AdminEditNotingList}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminAddNoting.url}
        component={AdminAddNoting}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminAddNoting.url}
        component={AdminAddNoting}
      />
      <AdminRoute
        exact={true}
        path={CONSTANT.component.adminDak.url}
        component={AdminDak}
      />
      {/* admin routes */}
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.userFileReport.url}
        component={HODFileReport}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.pendingHodFiles.url}
        component={PendingHodFiles}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.hodApproveFile.url}
        component={HodApproveFile}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.approvedFileReport.url}
        component={ApprovedFileList}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.EmpPropertyReturn.url}
        component={EmpPropertyReturn}
      />
      <EmpPropertyRoute
        exact={true}
        path={CONSTANT.component.EmpPropertyReturnForHr.url}
        component={HrPropertyReturnList}
      />

      <PrivateRoute
        exact={true}
        path={CONSTANT.component.userFileList.url}
        // component={UserFileList}
        component={FileStatsDashboard}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.myFiles.url}
        component={MyFiles}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.inbox.url}
        component={Inbox}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.DraftList.url}
        component={DraftFiles}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.outbox.url}
        component={Outbox}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.circularListAdd.url}
        component={CircularListFormAdd}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.circularFileDetail.url}
        component={CircularDetail}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.dltFIles.url}
        component={DltTempFiles}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.userParkedFileList.url}
        component={UserClosedFileList}
      />
      {/* <PrivateRoute
        exact={true}
        path={CONSTANT.component.userParkedFileList.url}
        component={ParkedFileList }
      /> */}
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.userParkedFileCommentDetails.url}
        component={ParkedFileComment}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.circularList.url}
        component={CircularList}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.intiateParkedFile.url}
        component={IntitateParkedFile}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.userSearchFile.url}
        component={UserSearchFile}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.userAddFile.url}
        component={MainFileCreate}
        // component={MainFileCreate2}
      />
      <PrivateRoute
        path={CONSTANT.component.partFile.url}
        component={PartFile}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.userFileDetail.url}
        component={UserFileDetail}
      />
      {/* <PrivateRoute exact={true} path={CONSTANT.component.commiteeNote.url} component={CommiteNoteList} />
            <PrivateRoute exact={true} path={CONSTANT.component.commiteeNoteAdd.url} component={AddCommiteNote} /> */}
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.userProfile.url}
        component={UserProfile}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.userChangePassword.url}
        component={UserChangePassword}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.userLeaveList.url}
        component={UserLeaveList}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.userApplyLeave.url}
        component={UserApplyLeave}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.userLeaveDetail.url}
        component={UserLeaveDetail}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.userETourList.url}
        component={EtourList}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.userAddETour.url}
        component={AddEtourRequest}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.userETourDetail.url}
        component={UserEtourDetail}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.DraftList.url}
        component={DraftList}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.userAddReimbursementDetail.url}
        component={AddReimbursementDetail}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.knowledgeManagementSystem.url}
        component={KnowledgeManagement}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.dakManagementCreate.url}
        component={DakManagementCreate}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.dakManagementList.url}
        component={DakManagementList}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.dakManagementUpdate.url}
        component={DakManagementUpdate}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.listMedicalClaim.url}
        component={ListMedicals}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.addMedicalClaim.url}
        component={AddMedicalClaim}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.medicalDesk.url}
        component={MedicalDesk}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.medicalClaimList.url}
        component={AppliedMedical}
      />
      {/* encashment */}
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.userLeaveEncashmentList.url}
        component={UserLeaveEncashmentList}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.userLeaveEncashmentApply.url}
        component={UserLeaveEncashmentAdd}
      />
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.userLeaveEncashmentDetail.url}
        component={UserLeaveEncashmentDetail}
      />
      {/* encashment */}
      {/* // Efilling   */}
      <PrivateRoute
        exact={true}
        path={CONSTANT.component.eFilling.url}
        component={AddEfilling}
      />
      <Route component={FourZeroFour} />
    </Switch>
  );
};

export default Router;
